// tslint:disable:max-line-length

import React from 'react';

export const UtilityOverflow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <circle cx="8.5" cy="2.5" r="1.5" />
      <circle cx="8.5" cy="7.5" r="1.5" />
      <circle cx="8.5" cy="12.5" r="1.5" />
    </svg>
  );
};
